import ColGraph from './ColGraph';

export default ColGraph;
